import axois from "axios";
import { BaseApiService } from "./api-base";

export class SttApiService extends BaseApiService {
  constructor(host: string) {
    super("stt");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  recognizeAgain(profile_ref: any, bucket: any, file_name: any) {
    const path = `${this.url}/v2/repeat_rec`;
    const body = {
      profile_ref: profile_ref,
      bucket,
      file_name,
    };
    return this.http.post(path, body).then((response) => response.data);
  }
}
